import { Equation } from "./equation";

export * from "./equation";

export default Equation;
